import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";
import { getTrainingStateTranslation } from "module/training/helper/getTrainingStateTranslation";
import { TrainingState } from "module/training/types";

interface Props {
  state: TrainingState;
}

const TrainingNameLabelField: React.FC<Props> = ({ state }) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.training.stateText,
        label: getTrainingStateTranslation(state),
      }}
    />
  );
};

export default React.memo(TrainingNameLabelField);
